import type { DatasetMetric } from "@models/Metric";

/**
 * List-visibility filter, per PRD-67: "List both Percentage and Mean
 * metrics" — unlike Bar Chart (Percentage-only), Line Chart has no result-type
 * restriction at all.
 */
export function metricHasPercentageOrMeanResultType(): boolean {
  return true;
}

/**
 * Line Chart selectability for a listed metric: disabled only when its
 * definition isn't resolved yet — same rule as Bar Chart
 * (isMetricEligibleForBarChart), no rollup-collapse exclusion (Scorecard's
 * is the only consumer that excludes one).
 */
export function isMetricEligibleForLineChart(
  metric: DatasetMetric,
): { eligible: boolean; reason?: string } {
  if (!metric.source) {
    return { eligible: false, reason: "This metric's definition isn't resolved yet." };
  }
  return { eligible: true };
}

// Line Chart's focus vocabulary (focusMode: VARIABLE/VALUE, focusEntity,
// focusRollup, categoryRollups) is identical in shape to Bar Chart's — same
// field names, same /search request contract (confirmed in
// DashboardFilters.tsx's LINE block) — so the metric -> focus-params
// resolution and the question-detail-fetch predicate are reused verbatim
// rather than re-implemented. numeric (Mean) already resolves correctly via
// the existing switch's `case "numeric": return {};` branch (no
// request-level focus for a Number/Float variable subset, same treatment as
// multiple_one_dimensional) — it was simply unreachable for Bar Chart, which
// excludes Mean metrics at the eligibility step above.
export {
  buildBarChartFocusParamsFromMetric as buildLineChartFocusParamsFromMetric,
  barChartMetricNeedsQuestionDetailFetch as lineChartMetricNeedsQuestionDetailFetch,
  type BarChartMetricFocusParams as LineChartMetricFocusParams,
} from "@components/charts/bar-chart-config/metric-source/bar-chart-metric-utils";
